import ky from "ky";
import * as cookie from "cookie";
import type { NormalizedOptions } from "ky";

const CSRF_REFRESH_TOKEN_NAME = `${import.meta.env.VITE_TOKEN_COOKIE_PREFIX}csrf_refresh_token`;

const CSRF_ACCESS_TOKEN_NAME = `${import.meta.env.VITE_TOKEN_COOKIE_PREFIX}csrf_access_token`;

function getCsrfRefreshToken(): string {
  const cookies = cookie.parse(document.cookie);
  const refreshCsrf = cookies[CSRF_REFRESH_TOKEN_NAME];
  return refreshCsrf ?? "";
}

async function refreshToken(
  req: Request,
  _opts: NormalizedOptions,
  res: Response,
) {
  if (res.status == 401) {
    const refreshRes = await ky.post("users/refresh", {
      prefixUrl: import.meta.env.VITE_EXT_API_URL,
      headers: {
        "X-CSRF-Token": getCsrfRefreshToken(),
      },
      credentials: "include",
      throwHttpErrors: false, // we don't care if this fails, it probably will if not logged in
    });
    if (refreshRes.status === 200) {
      return await ky(req, {
        throwHttpErrors: false,
      });
    }
  }
}

function attachCsrfAccessToken(req: Request) {
  const cookies = cookie.parse(document.cookie);
  const accessCsrf = cookies[CSRF_ACCESS_TOKEN_NAME];
  if (accessCsrf) req.headers.append("X-CSRF-Token", accessCsrf);
}

const base = ky.create({
  hooks: {
    beforeRequest: [attachCsrfAccessToken],
    afterResponse: [refreshToken],
  },
  credentials: "include",
  timeout: 1000 * 60 * 5, // 5 mins
});

const auth = base.extend({
  prefixUrl: import.meta.env.VITE_EXT_API_URL,
});

const detector = base.extend({
  prefixUrl: import.meta.env.VITE_DET_API_URL,
});

const payment = base.extend({
  prefixUrl: import.meta.env.VITE_PAY_API_URL,
});

const governance = base.extend({
  prefixUrl: import.meta.env.VITE_GOV_API_URL,
});

const apiSvc = base.extend({
  prefixUrl: import.meta.env.VITE_API_SVC_URL,
});

export const api = {
  /**
   * @deprecated use `auth` instead
   */
  ext: auth,
  auth,
  detector,
  payment,
  governance,
  apiSvc,
} as const;
